(function () {
    "use strict";

    angular
        .module("app")
        .component("twoFactorSetup", { // two-factor-setup
            templateUrl: "src/app/twoFactorSetup/twoFactorSetup.html",
            controller: controller
        });

    function controller($http, toast) {
        const $ctrl = this;
        $ctrl.form = {
            barcodeUri: "",
            verifyKey: "",
            verifyMsg: ""
        };
        $ctrl.ui = {
            state: "setup",
            loading: true,
            busy: false,
            verified: false,
            canVerify: () => {
                return !$ctrl.ui.busy && $ctrl.form.verifyKey && ($ctrl.form.verifyKey.length > 3) && !$ctrl.ui.verified;
            },
            canSave: () => {
                return !$ctrl.ui.busy && $ctrl.ui.verified;
            },
            canDisableTwoFactor: () => {
                return !$ctrl.ui.busy;
            }
        };

        $ctrl.$onInit = () => {
            // get qr code
            $http
                .get("/api/security/two-factor-setup")
                .then(result => {
                    const data = result.data;
                    $ctrl.form.barcodeUri = data.barcodeUri;
                    if (data.is_2_factor_enabled)
                        $ctrl.ui.state = "turnOff";
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.loading = false);
        };

        $ctrl.verifyClicked = () => {
            $ctrl.ui.busy = true;
            $ctrl.form.verifyMsg = "";
            $http
                .post("/api/security/two-factor-verify", { key: $ctrl.form.verifyKey })
                .then(result => {
                    const data = result.data;
                    $ctrl.form.verifyMsg = data.reason;

                    if (data.success)
                        $ctrl.ui.verified = true;
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        };

        $ctrl.saveClicked = () => {
            $ctrl.ui.busy = true;
            $http
                .post("/api/security/two-factor-enable")
                .then(result => {
                    toast.success("Two Factor Setup", "Two factor has been enabled.");
                    $ctrl.ui.state = "turnOff";
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        };

        $ctrl.disableTwoFactorClicked = () => {
            $ctrl.ui.busy = true;
            $http
                .post("/api/security/two-factor-disable")
                .then(() => {
                    $ctrl.ui.loading = true;
                    $ctrl.ui.verified = false;
                    $ctrl.form.verifyKey = "";

                    $http
                        .get("/api/security/two-factor-setup")
                        .then(result => {
                            const data = result.data;
                            $ctrl.form.barcodeUri = data.barcodeUri;
                            toast.success("Two Factor Setup", "Two factor has been disabled.");
                            $ctrl.ui.state = "setup";
                        })
                        .catch(toast.errorHandler)
                        .finally(() => $ctrl.ui.loading = false);
                })
                .catch(toast.errorHandler)
                .finally(() => $ctrl.ui.busy = false);
        };
    }
    controller.$inject = ["$http", "stToastFactory"];

})()